import React from 'react';
import { motion } from 'framer-motion';
interface SurveyOptionProps {
  emoji: string;
  text: string;
  onClick: () => void;
  selected?: boolean;
}
export function SurveyOption({
  emoji,
  text,
  onClick,
  selected
}: SurveyOptionProps) {
  return <motion.button onClick={onClick} whileHover={{
    scale: 1.02,
    backgroundColor: 'rgba(180, 80, 146, 0.1)'
  }} whileTap={{
    scale: 0.98
  }} className={`w-full max-w-lg mx-auto p-4 mb-3 rounded-xl border transition-all duration-300 flex items-center gap-4 group text-left bg-white
        ${selected ? 'border-[#B45092] shadow-lg ring-2 ring-[#B45092]/20' : 'border-[#B45092]/30 hover:border-[#B45092] shadow-sm'}
      `} data-id="element-82">
      <span className="text-xl filter drop-shadow-md group-hover:scale-110 transition-transform duration-300" data-id="element-83">
        {emoji}
      </span>
      <span className="text-[#121212] font-medium text-sm md:text-base tracking-wide" data-id="element-84">
        {text}
      </span>
    </motion.button>;
}